import ApiService from './ApiService'
import Vue from "vue";
import VueAxios from "vue-axios";
import axios from "axios";

Vue.use(VueAxios, axios)

export const Statistics2Service = {

  baseURL: process.env.VUE_APP_STATISTICS_V2_URL,

  getHearingDashboardData(params) {
    return Vue.axios.get(`${this.baseURL}/v1/hear`, {params: params})
  },

  getMonthlyDashboardData(params) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${this.baseURL}/v1/hear/monthly-metrics`, params)
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })
  },

  getOpsStatsData(params) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${this.baseURL}/v1/ops`, params)
       .then(response => resolve(response.data))
       .catch(error => reject(error))
    })
  },

  downloadOpsExcel(params) {
    return ApiService.blob(`${this.baseURL}/v1/ops/export-excel`, params)
  },

}
